import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

import { AuthService } from "../../../auth.service";
import { Router } from "@angular/router";
import { Messages } from "../../../model/messages";
import { Involved } from "../../../model/involved";
import { Navigation } from "../../../model/navigation";
import { Ticket } from "../../../model/ticket";
import { InvolvedService } from "../../../services/involved.service";
import { NavigationHelper } from "../../../services/navigation.helper";
import { FormGroup } from "@angular/forms";
import { TicketService } from "../../../services/ticket.service";
import { UsersService } from "../../../services/users.service";
import { Labeler } from "../../../model/labeler";

@Component({
  selector: "involved",

  templateUrl: "./involved.component.html",
  styleUrls: ["./involved.component.css"],
})
export class InvolvedComponent implements OnInit {
  messages: BehaviorSubject<Messages>;
  @Output() involvedSelected = new EventEmitter<number>();
  @Output() refreshTimeline = new EventEmitter<void>();

  @Input() isMobile: boolean = false;
  completionUrl = new BehaviorSubject<string>("");
  involveds: BehaviorSubject<Involved[]>;
  involved = new BehaviorSubject<Involved>(new Involved(0, 0, ""));
  selectedInvolved: Involved | null = null;
  title: BehaviorSubject<string> = new BehaviorSubject<string>("");
  @Input() currentTicket: Observable<Ticket>;
  currentId: number | null;
  showCreateForm: boolean = true;
  showDetails: boolean = false;
  editMode: boolean = false;
  involvedForm: FormGroup;
  involvedTitle: string = "involvedDetails.title.involved.details";

  constructor(
    private involvedService: InvolvedService,
    private authService: AuthService,
    private router: Router,
    private nav: NavigationHelper,
    private ticketService: TicketService,
    private users: UsersService
  ) {
    this.messages = new BehaviorSubject(Messages.EMPTY);
    this.involveds = new BehaviorSubject<Involved[]>([]);
  }

  ngOnInit(): void {
    this.title.next("involved.title");

    if (this.currentTicket) {
      this.currentTicket.subscribe((ticket) => {
        this.currentId = ticket.id;

        if (ticket.parts?.ticketInvolved) {
          this.involvedService.accept(ticket.parts.ticketInvolved);
        } else {
          this.involvedService.accept([]);
        }
      });

      this.involvedService.involvedObservable.subscribe((involved) => {
        this.involveds.next(involved);
      });
    }

    this.showCreateForm = false;

    this.nav.fragmentId.subscribe((id) => {
      const fragmentId = Number(id);

      if (this.nav.currentFragmentTopic === "involved") {
        if (fragmentId === -9) {
          this.showCreateForm = true;
          this.editMode = true;
          const newInvolved = new Involved(-9, 0, "");
          this.selectedInvolved = newInvolved;
          this.involvedService.select(newInvolved);
        } else if (fragmentId > 0) {
          const found = this.involveds.value.find((t) => t.id === fragmentId);
          if (found) {
            this.selectedInvolved = found;
            this.involvedService.select(found);

            if (this.nav.currentAction === "fragment") {
              this.showDetails = true;
            } else if (this.nav.currentAction === "fragmentedit") {
              this.showDetails = true;
              this.editMode = true;
            }
          }
        }
      }
    });
  }
  onFormClosed(): void {
    this.showCreateForm = false;
    this.selectedInvolved = null;
  }

  select(involved: Involved): void {
    this.showCreateForm = false;
    this.selectedInvolved = involved;
    this.involvedService.select(involved);

    const involvedId: number = involved.id;

    const url =
      "tickets/" + this.currentId + "/fragment/involved/" + involvedId;

    if (involvedId) {
      this.router.navigate([url]).then(() => {
        this.involvedSelected.emit(involvedId);
      });
    }
    this.showCreateForm = false;
  }

  removeInvolved(involved: Involved): void {
    const token = this.authService.token;
    const ticketId = involved.ticketId;

    if (involved && involved.id && involved.ticketId) {
      this.involvedService
        .deleteInvolved(token, involved.ticketId, involved.id)
        .subscribe(
          (response) => {
            this.messages.next(response);
            this.ticketService
              .getTicketWithParts(token, ticketId)
              .subscribe((messages) => {
                this.messages.next(messages);
                this.refreshTimeline.emit();
              });
            this.involved.next(Involved.EMPTY);
          },
          (error) => {
            this.messages.next(
              Messages.from({ involved: ["involved.delete.failed"] })
            );
          }
        );
    }
  }

  createInvolved(): void {
    this.selectedInvolved = null;
    this.showCreateForm = true;
    const newInvolved = new Involved(Navigation.NEW, 0, "");
    this.involvedService.selectedInvolved.next(newInvolved);

    const url =
      "tickets/" + this.currentId + "/fragmentedit/involved/" + Navigation.NEW;

    this.router.navigate([url]).then(() => {
      this.involvedSelected.emit(Navigation.NEW);
    });
  }
  userLabel(involved: Involved): string {
    const label = this.users.labelForId(Number(involved.involved));
    return label;
  }
}
